const archives = ['executed', 'archivecust', 'archivecarrier', 'archagreement']; // Статусы которые попадают в общую группу архив

/* // для хардкода цены / todo убрать когда будет цена выгружаться
function randomInteger(min, max) {
  let rand = min + Math.random() * (max + 1 - min);
  return Math.floor(rand);
}
*/

// Корректирую пришедшие данные (удаляю всё ненужное и убираю лишнюю вложенность)
export const dataAdjustmentResponse = order => {
  const {
    requestId: request = null,
    profiles = [],
    number = null,
  } = order.offerId;
  const status = order.orderStatusId;
  let newData = {
    id: order.orderId,
    info: {
      orderNumber: order.number,
      offerNumber: number,
      create: order.createdAt,
      change: order.updatedAt,
    },
    view: {
      id:
        request && request.serviceTypeId && request.serviceTypeId.serviceTypeId,
      abbr:
        request &&
        request.serviceTypeId &&
        request.serviceTypeId.serviceTypeAbbr,
      key:
        request &&
        request.serviceTypeId &&
        request.serviceTypeId.serviceTypeKey,
      type:
        request && request.serviceTypeId && request.serviceTypeId.serviceType,
      color: '',
      description: '',
    },
    state: {
      status: status && status.orderStatus.split('.')[0], // "Архив. Снят по соглашению сторон." => "Архив"
      statusKey: status && status.orderStatusKey,
      statusId: status && status.orderStatusId,
      statusKeyGroup: status && status.orderStatusKey, // снизу проверка к какой группе относится
      color: '',
      description:
        order.orderStatusId &&
        order.orderStatusId.orderStatus
          .split('.')
          .slice(1)
          .join('.'), // "Архив. Снят по соглашению сторон." => "Снят по соглашению сторон"
    },
    passengers: request.passengersCount,
    kids: request.kidsCount,
    accompCount: request.accompCount,
    price: order.offerId && order.offerId.price,
    totalPrice: order.offerId && order.offerId.totalPrice,
    routeLength: request.length,
    dateApplication: request.arrivalDatetime,
    placeDelivery: {
      city:
        request.routes && request.routes.length
          ? request.routes[0].route.split(',')[0]
          : 'Не указано',
      address:
        request.routes && request.routes.length
          ? request.routes[0].route
              .split(',')
              .slice(1)
              .join(',')
          : '',
    },
    finalDestination: {
      city:
        request.routes && request.routes.length
          ? request.routes[request.routes.length - 1].route.split(',')[0]
          : 'Не указано',
      address:
        request.routes && request.routes.length
          ? request.routes[request.routes.length - 1].route
              .split(',')
              .slice(1)
              .join(',')
          : '',
    },
    settlementForm: {
      id: request.paymentMethodId
        ? request.paymentMethodId.paymentMethodId
        : null,
      description: request.paymentMethodId
        ? request.paymentMethodId.paymentMethod
        : null,
    },
    region: {
      id:
        request.routes && request.routes.length
          ? request.routes[0].regionId
          : '',
    },
    dayOfWeeks: {
      days:
        request.dayOfWeeks && request.dayOfWeeks.length > 0
          ? request.dayOfWeeks[0]
          : '',
    },
    driver:
      profiles &&
      profiles
        .filter(
          profile => profile.roleId && profile.roleId.roleKey === 'driver'
        )
        .map(profile => {
          let userName = '';
          if (profile.userId) {
            userName += profile.userId.lastname
              ? `${profile.userId.lastname} `
              : '';
            userName += profile.userId.name
              ? `${profile.userId.name[0].toUpperCase()}.`
              : '';
            userName += profile.userId.patronymic
              ? `${profile.userId.patronymic[0].toUpperCase()}.`
              : '';
            userName = userName.trim();
          }
          return {
            id: profile.profileId,
            userName,
          };
        }),
    watched: !!order.viewLog,
    map: null,
  };

  if (request.routes && request.routes.length > 0) {
    newData.map = {
      id: order.orderId,
      article: number,
      dateApplication: request.arrivalDatetime,
      address: request.routes[0].route,
      latlng:
        request.routes[0].latitude && request.routes[0].longitude
          ? [+request.routes[0].latitude, +request.routes[0].longitude]
          : null,
    };
  }

  if (archives.some(key => key === newData.state.statusKeyGroup)) {
    newData.state.statusKeyGroup = 'archive';
  }
  if (
    (!newData.passengers || parseInt(newData.passengers) === 0) &&
    ((newData.kids && newData.kids !== '') ||
      (newData.accompCount && newData.accompCount !== ''))
  ) {
    newData.passengers = parseInt(newData.kids) + parseInt(newData.accompCount);
  }

  return newData;
};

// Корректирую данные для отправки
export const dataAdjustmentFiltersRequest = filters => {
  const { search = false, fields = false } = filters;
  let newData = {};
  if (search) {
    newData.search_entry = search;
  }
  if (fields) {
    if (fields.serviceTypes) newData.service_type_key = fields.serviceTypes;
    if (fields.passengersMin)
      newData['passengers_count[from]'] = fields.passengersMin;
    if (fields.passengersMax)
      newData['passengers_count[to]'] = fields.passengersMax;
    if (fields.arrivalFrom)
      newData['arrival_datetime[from]'] = fields.arrivalFrom.format(
        'YYYY-MM-DD 00:00:00'
      );
    if (fields.arrivalTo)
      newData['arrival_datetime[to]'] = fields.arrivalTo.format(
        'YYYY-MM-DD 23:59:59'
      );
    if (fields.weekDays) newData.day_of_week_key = fields.weekDays;
  }
  return newData;
};
